import { Injectable } from '@angular/core';
import 'parse';
import { TchekService } from './tchek.service';
import { AdminSearch, Attributes, FinderData, SearchTagCheckbox } from '../model/search';
import { Tchekb } from '../model/tchekb.model';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { LogsService } from './logs.service';
import { AnnotationService } from './annotation.service';
import { RoiService } from './roi.service';
import { LocalstorageService } from './localstorage.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { UserService } from './user.service';
import { User } from 'parse';
 import { ClassificationService } from './classification.service';
import { Device } from '../model/device.model';
import { UserParse } from '../model/user';
import { TchekOldService } from './tchek-old.service';

const parse: typeof Parse = require('parse');

@Injectable()
export class SearchService {
  moment = require('moment/moment');
  isSuperAdmin: boolean = false;
  public lastFinderData 
  public searchCount
  public companyPtr;
  public companyDevicesPtr = [];
  public APITokenForNonAdminUsers;

  constructor(
    private readonly i18n: I18n,
    private readonly _tchekService: TchekService,
    private readonly _logsService: LogsService,
    private readonly _annotationService: AnnotationService,
    private readonly _roiService: RoiService,
    private readonly _userService: UserService,
    private readonly _classificationService: ClassificationService,
    private readonly _tchekOldService: TchekOldService,

    private _localStorageService: LocalstorageService) {
    this.isSuperAdmin = parse.User.current().get('isSuperAdmin');
    if (!this.isSuperAdmin) {
      this.companyPtr = parse.User.current().get('companyPtr');
    }
  }

  private async fastenSpeedForNonAdmin() {
    if (!this.isSuperAdmin) {
      this.companyDevicesPtr = await this.getDevicesCompany(this.companyPtr);
      console.log(">>> fastenSpeed this.companyDevicesPtr",this.companyDevicesPtr);
      this.APITokenForNonAdminUsers = await this._userService.getAPIToken(this.companyPtr);
    }
  }

  finderDataAdminHistory: string;
  public fuzzySearch(finderData: FinderData): Promise<any> {
    return new Promise(async (resolve, reject) => {


      console.log(">>> fuzzySearch SEARCH finderData:",new Date(),this.isSuperAdmin,this.companyPtr,finderData);
      
      if (this.isSuperAdmin && finderData.admin)
        this.finderDataAdminHistory = JSON.stringify(finderData.admin.searchTags)

      if (finderData.limit < 15)
        finderData.limit = 15;


      let immats = finderData.activeFilters.map<string>(f => f.value.toString());
      let dateLow = finderData.isDateActive ? finderData.date.start.startOf('day').toDate() : undefined;
      let dateHigh = finderData.isDateActive ? finderData.date.end.endOf('day').toDate() : undefined;

      const _tchek = parse.Object.extend('Tchek');
      const _vehicle = parse.Object.extend('Vehicle');

      const query = new parse.Query(_tchek);

      query.descending("tchekCreatedAt")
	    query.exists('vehiclePtr')
      query.include("thumbnailImagePtr")
	 
      if (finderData.deviceSelect !== null && finderData.deviceSelect !== undefined) {
        const devicePtr = {
          __type: 'Pointer',
          className: 'Device',
          objectId: finderData.deviceSelect
        };
        query.equalTo('devicePtr', devicePtr);
      } else {
        // for non-superAdmin users, we boost the request time 14s -> a few ms by selecting by company:
        //if (!this.isSuperAdmin && this.fcompanyPtr) query.equalTo("companyPtr", companyPtr);
        if (!this.isSuperAdmin && this.companyPtr) {
          await this.fastenSpeedForNonAdmin();
          query.containedIn("devicePtr", this.companyDevicesPtr);
        }
      }

      if (finderData.statusSelect) {
        switch (finderData.statusSelect) {
          case 'unread':
            query.equalTo('isNew', true);
            break;
          case 'read':
            query.equalTo('isNew', false);
            break;
          case 'litigation':
            query.equalTo('isFlagged', true);
            break;
          case 'inspected':
            query.equalTo('inspected', true);
            break;
          case 'processing':
            query.equalTo('detectionFinished', false);
            break;
          default:
            console.log('No activeStatus');
        }
      }
      if (finderData.isDownloaded) {
        query.equalTo('isUploaded', true);
      }
      if (finderData.scanAnnotated === true || finderData.scanAnnotated === false) {
        if (finderData.scanAnnotated)
          query.equalTo('isAnnotated', finderData.scanAnnotated);
        else
          query.notEqualTo('isAnnotated', true);
      }
      if (finderData.scanForValidation) {
        query.equalTo('forValidation', true);
      }
      if (finderData.isPicturesHD === true && finderData.isPicturesXHD === true) {
        query.equalTo('uploadHDPictures', true);
      } else if (finderData.isPicturesHD === false && finderData.isPicturesXHD === false) {
        query.equalTo('uploadHDPictures', false);
      } else if (finderData.isPicturesHD === true || finderData.isPicturesHD === false) {
        query.equalTo('uploadHDPictures', finderData.isPicturesHD);
        if (finderData.isPicturesHD === true) {
          query.notEqualTo('videoConverter', 2);
          query.notEqualTo('toDownload', 1);
        }
      } else if (finderData.isPicturesXHD === true || finderData.isPicturesXHD === false) {
        query.equalTo('uploadHDPictures', finderData.isPicturesXHD);
        if (finderData.isPicturesXHD === true) {
          query.equalTo('videoConverter', 2);
          query.notEqualTo('toDownload', 1);
        }
      }
      if (finderData.scanAnalyzed) {
        query.equalTo('detectionFinished', true);
      }

      if (finderData.minProbVehicle >= 0) {
        query.greaterThanOrEqualTo('probabilityVehicle', finderData.minProbVehicle);
      }
      if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch && this.trueLength(finderData.admin.searchTagList.typeTag) > 0) {
        for (let i = 0; i < finderData.admin.searchTagList.typeTag.length; i++) {
          let value = finderData.admin.searchTagList.typeTag[i].value.toString().substr(1);
          if (finderData.admin.searchTagList.typeTag[i].checked) {
            query.equalTo(value, true)
          }
        }
      }
      if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch && this.trueLength(finderData.admin.searchTagList.nTypeTag) > 0) {
        for (let i = 0; i < finderData.admin.searchTagList.nTypeTag.length; i++) {
          let value = finderData.admin.searchTagList.nTypeTag[i].value.toString().substr(1);
          if (finderData.admin.searchTagList.nTypeTag[i].checked) {
            query.notEqualTo(value, true)
          }
        }
      }
      if (immats.length > 0) {
        // Adding query constraints
        let queryVehicle;
        for (let i = 0; i < immats.length; i++) {
          if (i === 0) {
            queryVehicle = parse.Query.or(
              new parse.Query(_vehicle).contains('immat', immats[i].toLocaleUpperCase()),
              new parse.Query(_vehicle).contains('immat', immats[i].toLocaleLowerCase()),
              new parse.Query(_vehicle).contains('vin', immats[i].toLocaleUpperCase()),
              new parse.Query(_vehicle).contains('or', immats[i].toLocaleUpperCase())
            )
          }
          else
            queryVehicle = parse.Query.and(queryVehicle,
              parse.Query.or(
                new parse.Query(_vehicle).contains('immat', immats[i].toLocaleUpperCase()),
                new parse.Query(_vehicle).contains('immat', immats[i].toLocaleLowerCase()),
                new parse.Query(_vehicle).contains('vin', immats[i].toLocaleUpperCase()),
                new parse.Query(_vehicle).contains('or', immats[i].toLocaleUpperCase())
              )
            );
        }
        queryVehicle.notEqualTo('isDeleted', true);
        query.matchesQuery('vehiclePtr', queryVehicle);
      }
      if (dateLow)
        query.greaterThanOrEqualTo('tchekCreatedAt', dateLow);
      if (dateHigh)
        query.lessThanOrEqualTo('tchekCreatedAt', dateHigh);


      if ((this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch
        && (this.trueLength(finderData.admin.searchTagList.attributesTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0
          || this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0
          || this.trueLength(finderData.admin.searchTagList.classTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nClassTag) > 0))
        || (this.isSuperAdmin && finderData.admin && finderData.admin.damageSearch
          && (this.trueLength(finderData.admin.searchTagList.damageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0))) {
        query.limit(finderData.limit)
        const _annotation = parse.Object.extend('Annotation');
        const _user = parse.Object.extend('User');
        const _damage = parse.Object.extend('Damage');
        const _trace = parse.Object.extend('Trace');

        let annotationQuery = new parse.Query(_annotation);
        annotationQuery.matchesQuery("tchekPtr", query)
        let damageQuery = new parse.Query(_damage);
        damageQuery.matchesQuery("tchekPtr", query)
        let traceQuery = new parse.Query(_trace);
        traceQuery.matchesQuery("tchekPtr", query)

        if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch
          && (this.trueLength(finderData.admin.searchTagList.attributesTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0
            || this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0
            || this.trueLength(finderData.admin.searchTagList.classTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nClassTag) > 0)) {
          if (finderData.admin.searchTagList.attributesTag && this.trueLength(finderData.admin.searchTagList.attributesTag) > 0) {
            let nAttributesQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.attributesTag.length; i++) {
              let value = finderData.admin.searchTagList.attributesTag[i].value.toString().substr(1).split(':');
              let res = [{ name: value[0], value: value[1] }]
              // console.log("dove ", value);
              if (finderData.admin.searchTagList.attributesTag[i].checked && Q === 0) {
                nAttributesQuery = new parse.Query(_annotation).containedIn('attributes', res)
                Q++;
              } else if (finderData.admin.searchTagList.attributesTag[i].checked) {
                nAttributesQuery = parse.Query.or(nAttributesQuery,
                  new parse.Query(_annotation).containedIn('attributes', res)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, nAttributesQuery)
          }
          if (finderData.admin.searchTagList.nAttributesTag && this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0) {
            let attributesQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nAttributesTag.length; i++) {
              let value = finderData.admin.searchTagList.nAttributesTag[i].value.toString().substr(1).split(':');
              let res = [{ name: value[0], value: value[1] }]
              if (finderData.admin.searchTagList.nAttributesTag[i].checked && Q === 0) {
                attributesQuery = new parse.Query(_annotation).notContainedIn('attributes', res)
                Q++;
              } else if (finderData.admin.searchTagList.nAttributesTag[i].checked) {
                attributesQuery = parse.Query.or(attributesQuery,
                  new parse.Query(_annotation).notContainedIn('attributes', res)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, attributesQuery)
          }

          if (finderData.admin.searchTagList.userAnnotateTag && this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0) {
            let userAnnotateTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.userAnnotateTag.length; i++) {
              let value = finderData.admin.searchTagList.userAnnotateTag[i].value.toString().substr(1).split(':');
              if (finderData.admin.searchTagList.userAnnotateTag[i].checked && Q === 0) {
                userAnnotateTagQuery = new parse.Query(_user).equalTo('objectId', value[1])
                Q++;
              } else if (finderData.admin.searchTagList.userAnnotateTag[i].checked) {
                userAnnotateTagQuery = parse.Query.or(userAnnotateTagQuery,
                  new parse.Query(_user).equalTo('objectId', value[1])
                );
              }
            }
            annotationQuery.matchesQuery('userPtr', userAnnotateTagQuery)
          }
          if (finderData.admin.searchTagList.nUserAnnotateTag && this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0) {
            let nUserAnnotateTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nUserAnnotateTag.length; i++) {
              let value = finderData.admin.searchTagList.nUserAnnotateTag[i].value.toString().substr(1).split(':');
              if (finderData.admin.searchTagList.nUserAnnotateTag[i].checked && Q === 0) {
                nUserAnnotateTagQuery = new parse.Query(_user).notEqualTo('objectId', value[1])
                Q++;
              } else if (finderData.admin.searchTagList.nUserAnnotateTag[i].checked) {
                nUserAnnotateTagQuery = parse.Query.or(nUserAnnotateTagQuery,
                  new parse.Query(_user).notEqualTo('objectId', value[1])
                );
              }
            }
            annotationQuery.matchesQuery('userPtr', nUserAnnotateTagQuery)
          }

          if (finderData.admin.searchTagList.classTag && this.trueLength(finderData.admin.searchTagList.classTag) > 0) {
            let classQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.classTag.length; i++) {
              let value = finderData.admin.searchTagList.classTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.classTag[i].checked && Q === 0) {
                classQuery = new parse.Query(_annotation).equalTo('label', value)
                Q++;
              } else if (finderData.admin.searchTagList.classTag[i].checked) {
                classQuery = parse.Query.or(classQuery,
                  new parse.Query(_annotation).equalTo('label', value)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, classQuery)
          }
          if (finderData.admin.searchTagList.nClassTag && this.trueLength(finderData.admin.searchTagList.nClassTag) > 0) {
            let classQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nClassTag.length; i++) {
              let value = finderData.admin.searchTagList.nClassTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nClassTag[i].checked && Q === 0) {
                classQuery = new parse.Query(_annotation).notEqualTo('label', value)
                Q++;
              } else if (finderData.admin.searchTagList.nClassTag[i].checked) {
                classQuery = parse.Query.or(classQuery,
                  new parse.Query(_annotation).notEqualTo('label', value)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, classQuery)
          }


          annotationQuery
            .include('tchekPtr')
            .descending('createdAt')
            .include('tchekPtr.vehiclePtr')
            .include('tchekPtr.devicePtr')
            .limit(finderData.limit * 10)
            .skip(finderData.skip)
            .find().then(
              results => {
                // console.log("dove", results);

                var listTcheks = []
                results.forEach(element => {
                  let index = listTcheks.findIndex(t => {
                    return t.id === element.get('tchekPtr').id
                  })
                  if (index === -1)
                    if (element.get('tchekPtr').get('vehiclePtr'))
                      listTcheks.push(element.get('tchekPtr'))
                    else
                      this._logsService.saveLog("VehiclePtr is empty", element.id)
                });

                //  console.log("dove list", listTcheks);

                Promise.all(listTcheks.map(o => this._tchekService
                  .hydrateTchek(o, {
                    includeThumbnail: true
                  }))).then(tcheks => {
                    resolve(tcheks)
                  });

              },
              error => {
                reject(error);
              }
            );
        } else if (this.isSuperAdmin && finderData.admin && finderData.admin.damageSearch
          && (this.trueLength(finderData.admin.searchTagList.damageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0)) {

          if (this.trueLength(finderData.admin.searchTagList.damageTag) > 0) {
            let damageTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.damageTag.length; i++) {
              let value = finderData.admin.searchTagList.damageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.damageTag[i].checked && Q === 0) {
                damageTagQuery = new parse.Query(_damage).equalTo('type', value)
                Q++;
              } else if (finderData.admin.searchTagList.damageTag[i].checked) {
                damageTagQuery = parse.Query.or(damageTagQuery,
                  new parse.Query(_damage).equalTo('type', value)
                );
              }
            }
            damageQuery = parse.Query.and(damageQuery, damageTagQuery)
          }
          if (this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0) {
            let nDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.nDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.nDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nDamageTag[i].checked && Q === 0) {
                nDamageTagQuery = new parse.Query(_damage).notEqualTo('type', value)
                Q++;
              } else if (finderData.admin.searchTagList.nDamageTag[i].checked) {
                nDamageTagQuery = parse.Query.or(nDamageTagQuery,
                  new parse.Query(_damage).notEqualTo('type', value)
                );
              }
            }
            damageQuery = parse.Query.and(damageQuery, nDamageTagQuery)
          }

          if (this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0) {
            let editDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.editDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.editDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.editDamageTag[i].checked && Q === 0) {
                if (value === 'delDamage')
                  editDamageTagQuery = new parse.Query(_damage).equalTo('isDeleted', true)
                if (value === 'addDamage')
                  editDamageTagQuery = new parse.Query(_damage).notEqualTo('isAuto', true)
                Q++;
              } else if (finderData.admin.searchTagList.editDamageTag[i].checked) {
                if (value === 'delDamage')
                  editDamageTagQuery = parse.Query.or(editDamageTagQuery,
                    new parse.Query(_damage).equalTo('isDeleted', true))
                if (value === 'addDamage')
                  editDamageTagQuery = parse.Query.or(editDamageTagQuery,
                    new parse.Query(_damage).notEqualTo('isAuto', true));
              }
            }
            damageQuery = parse.Query.and(damageQuery, editDamageTagQuery)
          }
          if (this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0) {
            let nEditDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.nEditDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.nEditDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nEditDamageTag[i].checked && Q === 0) {
                if (value === 'delDamage')
                  nEditDamageTagQuery = new parse.Query(_damage).notEqualTo('isDeleted', true)
                if (value === 'addDamage')
                  nEditDamageTagQuery = new parse.Query(_damage).equalTo('isAuto', true)
                Q++;
              } else if (finderData.admin.searchTagList.nEditDamageTag[i].checked) {
                let tmpQuery;
                if (value === 'delDamage')
                  tmpQuery = new parse.Query(_damage).notEqualTo('isDeleted', true)
                if (value === 'addDamage')
                  tmpQuery = new parse.Query(_damage).equalTo('isAuto', true)
                nEditDamageTagQuery = parse.Query.or(nEditDamageTagQuery, tmpQuery);
              }
            }
            damageQuery = parse.Query.and(damageQuery, nEditDamageTagQuery)
          }

          if (this._classificationService.active) {
            damageQuery.equalTo('isAuto', true)
            damageQuery.notEqualTo('classification', true)
            damageQuery.notEqualTo('skipClassification', true)
            damageQuery.notEqualTo('skipClassificationIDK', true)
          }

          damageQuery
            .include('tchekPtr')
            .descending('createdAt')
            .include('tchekPtr.vehiclePtr')
            .include('tchekPtr.devicePtr')
            .limit(finderData.limit * 10)
            .skip(finderData.skip)
            .find().then(
              results => {
                // console.log("dove" , results);
                var listTcheks = []
                results.forEach(element => {
                  let index = listTcheks.findIndex(t => {
                    return t.id === element.get('tchekPtr').id
                  })
                  if (index === -1)
                    if (element.get('tchekPtr').get('vehiclePtr'))
                      listTcheks.push(element.get('tchekPtr'))
                    else
                      this._logsService.saveLog("VehiclePtr is empty", element.id)
                });

                Promise.all(listTcheks.map(o => this._tchekService
                  .hydrateTchek(o, {
                    includeThumbnail: true
                  }))).then(tcheks => {
                    resolve(tcheks)
                  });

              },
              error => {
                reject(error);
              }
            );
        }
      } else {
        query.notEqualTo('isDeleted', true)
          .descending('tchekCreatedAt')
          .include('vehiclePtr')
          .include('devicePtr')
          .limit(finderData.limit)
          .skip(finderData.skip)
          .find().then(
            results => {
				let result = [];

				results.forEach(async element => {
					if (!element.get('devicePtr'))element.set('devicePtr',{
						__type: 'Pointer',
						className: 'Device',
						objectId: 'B9TGfpxLR6'
					  } )

					  if (element.get('resultAltoApi') && element.get('companyPtr') ){
 						if (!this._roiService.tokenMemory.get(element.get('companyPtr').id)){
              // for non-superAdmin users, we:
              // - do just one query instead of $limit ones
              // - which boost the request time 8s -> a few ms by selecting by company
              if (!this.isSuperAdmin && this.companyPtr) {
                if (this.APITokenForNonAdminUsers) this._roiService.tokenMemory.set(element.get('companyPtr').id, this.APITokenForNonAdminUsers);
              } else { // we let the shitty current behavior for superAdmin
                this._roiService.tokenMemory.set(element.get('companyPtr').id, await this._userService.getAPIToken(this.companyPtr));
              }
						} 
					}

				if (element.get('vehiclePtr'))
					result.push(element)
					else{
					this._logsService.saveLog("VehiclePtr is empty", element.id)
					console.log('no vehicle ptr',  element.id);
				}
				});
				
				console.log(result);
              // console.log('results ', results.map(o => o.get('immat')));
              Promise.all(result.map(o => this._tchekService
                .hydrateTchek(o, {
                  includeThumbnail: true
                }))).then(tcheks => {
                  resolve(tcheks)
                });
            },
            error => {
              reject(error);
            }
          );
      }
    });
  }

  //////////////////////////// FOR COUNT 
  public fuzzySearchCount(finderData: FinderData): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log("DEBUG: >>> fuzzySearch COUNT finderData:",finderData);

      if (finderData.limit < 15)
        finderData.limit = 15;


      let immats = finderData.activeFilters.map<string>(f => f.value.toString());
      let dateLow = finderData.isDateActive ? finderData.date.start.startOf('day').toDate() : undefined;
      let dateHigh = finderData.isDateActive ? finderData.date.end.endOf('day').toDate() : undefined;

      const _tchek = parse.Object.extend('Tchek');
      const _vehicle = parse.Object.extend('Vehicle');

      const query = new parse.Query(_tchek);
      if (finderData.deviceSelect !== null) {
        const devicePtr = {
          __type: 'Pointer',
          className: 'Device',
          objectId: finderData.deviceSelect
        };
        query.equalTo('devicePtr', devicePtr);
      }
      if (finderData.statusSelect) {
        switch (finderData.statusSelect) {
          case 'unread':
            query.equalTo('isNew', true);
            break;
          case 'read':
            query.equalTo('isNew', false);
            break;
          case 'litigation':
            query.equalTo('isFlagged', true);
            break;
          case 'inspected':
            query.equalTo('inspected', true);
            break;
          case 'processing':
            query.equalTo('detectionFinished', false);
            break;
          default:
            console.log('No activeStatus');
        }
      }
      if (finderData.isDownloaded) {
        query.equalTo('isUploaded', true);
      }
      if (finderData.scanAnnotated === true || finderData.scanAnnotated === false) {
        if (finderData.scanAnnotated)
          query.equalTo('isAnnotated', finderData.scanAnnotated);
        else
          query.notEqualTo('isAnnotated', true);
      }
      if (finderData.scanForValidation) {
        query.equalTo('forValidation', true);
      }
      if (finderData.isPicturesHD === true || finderData.isPicturesHD === false) {
        query.equalTo('uploadHDPictures', finderData.isPicturesHD);
      }
      if (finderData.scanAnalyzed) {
        query.equalTo('detectionFinished', true);
      }
      if (finderData.minProbVehicle >= 0) {
        query.greaterThanOrEqualTo('probabilityVehicle', finderData.minProbVehicle);
      }
      if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch && this.trueLength(finderData.admin.searchTagList.typeTag) > 0) {
        for (let i = 0; i < finderData.admin.searchTagList.typeTag.length; i++) {
          let value = finderData.admin.searchTagList.typeTag[i].value.toString().substr(1);
          if (finderData.admin.searchTagList.typeTag[i].checked) {
            query.equalTo(value, true)
          }
        }
      }
      if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch && this.trueLength(finderData.admin.searchTagList.nTypeTag) > 0) {
        for (let i = 0; i < finderData.admin.searchTagList.nTypeTag.length; i++) {
          let value = finderData.admin.searchTagList.nTypeTag[i].value.toString().substr(1);
          if (finderData.admin.searchTagList.nTypeTag[i].checked) {
            query.notEqualTo(value, true)
          }
        }
      }
      if (immats.length > 0) {
        // Adding query constraints
        let queryVehicle;
        for (let i = 0; i < immats.length; i++) {
          if (i === 0) {
            queryVehicle = parse.Query.or(
              new parse.Query(_vehicle).contains('immat', immats[i].toLocaleUpperCase()),
              new parse.Query(_vehicle).contains('immat', immats[i].toLocaleLowerCase()),
              new parse.Query(_vehicle).contains('vin', immats[i].toLocaleUpperCase()),
              new parse.Query(_vehicle).contains('or', immats[i].toLocaleUpperCase())
            )
          }
          else
            queryVehicle = parse.Query.and(queryVehicle,
              parse.Query.or(
                new parse.Query(_vehicle).contains('immat', immats[i].toLocaleUpperCase()),
                new parse.Query(_vehicle).contains('immat', immats[i].toLocaleLowerCase()),
                new parse.Query(_vehicle).contains('vin', immats[i].toLocaleUpperCase()),
                new parse.Query(_vehicle).contains('or', immats[i].toLocaleUpperCase())
              )
            );
        }
        queryVehicle.notEqualTo('isDeleted', true);
        query.matchesQuery('vehiclePtr', queryVehicle);
      }
      if (dateLow)
        query.greaterThanOrEqualTo('tchekCreatedAt', dateLow);
      if (dateHigh)
        query.lessThanOrEqualTo('tchekCreatedAt', dateHigh);

      if ((this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch
        && (this.trueLength(finderData.admin.searchTagList.attributesTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0
          || this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0
          || this.trueLength(finderData.admin.searchTagList.classTag) > 0
          || this.trueLength(finderData.admin.searchTagList.nClassTag) > 0))
        || (this.isSuperAdmin && finderData.admin && finderData.admin.damageSearch
          && (this.trueLength(finderData.admin.searchTagList.damageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0))) {
        query.limit(finderData.limit)
        const _annotation = parse.Object.extend('Annotation');
        const _damage = parse.Object.extend('Damage');
        const _trace = parse.Object.extend('Trace');
        const _user = parse.Object.extend('User');

        let annotationQuery = new parse.Query(_annotation);
        annotationQuery.matchesQuery("tchekPtr", query)
        let damageQuery = new parse.Query(_damage);
        damageQuery.matchesQuery("tchekPtr", query)
        let traceQuery = new parse.Query(_trace);
        traceQuery.matchesQuery("tchekPtr", query)

        if (this.isSuperAdmin && finderData.admin && finderData.admin.annotateSearch
          && (this.trueLength(finderData.admin.searchTagList.attributesTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0
            || this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0
            || this.trueLength(finderData.admin.searchTagList.classTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nClassTag) > 0)) {

          if (finderData.admin.searchTagList.attributesTag && this.trueLength(finderData.admin.searchTagList.attributesTag) > 0) {
            let nAttributesQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.attributesTag.length; i++) {
              let value = finderData.admin.searchTagList.attributesTag[i].value.toString().substr(1).split(':');
              let res = [{ name: value[0], value: value[1] }]
              if (finderData.admin.searchTagList.attributesTag[i].checked && Q === 0) {
                nAttributesQuery = new parse.Query(_annotation).containedIn('attributes', res)
                Q++;
              } else if (finderData.admin.searchTagList.attributesTag[i].checked) {
                nAttributesQuery = parse.Query.or(nAttributesQuery,
                  new parse.Query(_annotation).containedIn('attributes', res)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, nAttributesQuery)
          }
          if (finderData.admin.searchTagList.nAttributesTag && this.trueLength(finderData.admin.searchTagList.nAttributesTag) > 0) {
            let attributesQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nAttributesTag.length; i++) {
              let value = finderData.admin.searchTagList.nAttributesTag[i].value.toString().substr(1).split(':');
              let res = [{ name: value[0], value: value[1] }]
              if (finderData.admin.searchTagList.nAttributesTag[i].checked && Q === 0) {
                attributesQuery = new parse.Query(_annotation).notContainedIn('attributes', res)
                Q++;
              } else if (finderData.admin.searchTagList.nAttributesTag[i].checked) {
                attributesQuery = parse.Query.or(attributesQuery,
                  new parse.Query(_annotation).notContainedIn('attributes', res)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, attributesQuery)
          }

          if (finderData.admin.searchTagList.userAnnotateTag && this.trueLength(finderData.admin.searchTagList.userAnnotateTag) > 0) {
            let userAnnotateTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.userAnnotateTag.length; i++) {
              let value = finderData.admin.searchTagList.userAnnotateTag[i].value.toString().substr(1).split(':');
              if (finderData.admin.searchTagList.userAnnotateTag[i].checked && Q === 0) {
                userAnnotateTagQuery = new parse.Query(_user).equalTo('objectId', value[1])
                Q++;
              } else if (finderData.admin.searchTagList.userAnnotateTag[i].checked) {
                userAnnotateTagQuery = parse.Query.or(userAnnotateTagQuery,
                  new parse.Query(_user).equalTo('objectId', value[1])
                );
              }
            }
            annotationQuery.matchesQuery('userPtr', userAnnotateTagQuery)
          }
          if (finderData.admin.searchTagList.nUserAnnotateTag && this.trueLength(finderData.admin.searchTagList.nUserAnnotateTag) > 0) {
            let nUserAnnotateTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nUserAnnotateTag.length; i++) {
              let value = finderData.admin.searchTagList.nUserAnnotateTag[i].value.toString().substr(1).split(':');
              if (finderData.admin.searchTagList.nUserAnnotateTag[i].checked && Q === 0) {
                nUserAnnotateTagQuery = new parse.Query(_user).notEqualTo('objectId', value[1])
                Q++;
              } else if (finderData.admin.searchTagList.nUserAnnotateTag[i].checked) {
                nUserAnnotateTagQuery = parse.Query.or(nUserAnnotateTagQuery,
                  new parse.Query(_user).notEqualTo('objectId', value[1])
                );
              }
            }
            annotationQuery.matchesQuery('userPtr', nUserAnnotateTagQuery)
          }

          if (finderData.admin.searchTagList.classTag && this.trueLength(finderData.admin.searchTagList.classTag) > 0) {
            let classQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.classTag.length; i++) {
              let value = finderData.admin.searchTagList.classTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.classTag[i].checked && Q === 0) {
                classQuery = new parse.Query(_annotation).equalTo('label', value)
                Q++;
              } else if (finderData.admin.searchTagList.classTag[i].checked) {
                classQuery = parse.Query.or(classQuery,
                  new parse.Query(_annotation).equalTo('label', value)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, classQuery)
          }
          if (finderData.admin.searchTagList.nClassTag && this.trueLength(finderData.admin.searchTagList.nClassTag) > 0) {
            let classQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.nClassTag.length; i++) {
              let value = finderData.admin.searchTagList.nClassTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nClassTag[i].checked && Q === 0) {
                classQuery = new parse.Query(_annotation).notEqualTo('label', value)
                Q++;
              } else if (finderData.admin.searchTagList.nClassTag[i].checked) {
                classQuery = parse.Query.or(classQuery,
                  new parse.Query(_annotation).notEqualTo('label', value)
                );
              }
            }
            annotationQuery = parse.Query.and(annotationQuery, classQuery)
          }


          annotationQuery
            .include('tchekPtr')
            .descending('createdAt')
            .include('tchekPtr.vehiclePtr')
            .include('tchekPtr.devicePtr')
            .limit(finderData.limit)
            .skip(finderData.skip)
            .count().then(count => { resolve(count) })
        } else if (this.isSuperAdmin && finderData.admin && finderData.admin.damageSearch
          && (this.trueLength(finderData.admin.searchTagList.damageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0
            || this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0)) {

          if (this.trueLength(finderData.admin.searchTagList.damageTag) > 0) {
            let damageTagQuery;
            let Q = 0;
            for (let i = 0; i < finderData.admin.searchTagList.damageTag.length; i++) {
              let value = finderData.admin.searchTagList.damageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.damageTag[i].checked && Q === 0) {
                damageTagQuery = new parse.Query(_damage).equalTo('type', value)
                Q++;
              } else if (finderData.admin.searchTagList.damageTag[i].checked) {
                damageTagQuery = parse.Query.or(damageTagQuery,
                  new parse.Query(_damage).equalTo('type', value)
                );
              }
            }
            damageQuery = parse.Query.and(damageQuery, damageTagQuery)
          }
          if (this.trueLength(finderData.admin.searchTagList.nDamageTag) > 0) {
            let nDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.nDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.nDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nDamageTag[i].checked && Q === 0) {
                nDamageTagQuery = new parse.Query(_damage).notEqualTo('type', value)
                Q++;
              } else if (finderData.admin.searchTagList.nDamageTag[i].checked) {
                nDamageTagQuery = parse.Query.or(nDamageTagQuery,
                  new parse.Query(_damage).notEqualTo('type', value)
                );
              }
            }
            damageQuery = parse.Query.and(damageQuery, nDamageTagQuery)
          }

          if (this.trueLength(finderData.admin.searchTagList.editDamageTag) > 0) {
            let editDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.editDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.editDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.editDamageTag[i].checked && Q === 0) {
                if (value === 'delDamage')
                  editDamageTagQuery = new parse.Query(_damage).equalTo('isDeleted', true)
                if (value === 'addDamage')
                  editDamageTagQuery = new parse.Query(_damage).notEqualTo('isAuto', true)
                Q++;
              } else if (finderData.admin.searchTagList.editDamageTag[i].checked) {
                if (value === 'delDamage')
                  editDamageTagQuery = parse.Query.or(editDamageTagQuery,
                    new parse.Query(_damage).equalTo('isDeleted', true))
                if (value === 'addDamage')
                  editDamageTagQuery = parse.Query.or(editDamageTagQuery,
                    new parse.Query(_damage).notEqualTo('isAuto', true));
              }
            }
            damageQuery = parse.Query.and(damageQuery, editDamageTagQuery)
          }
          if (this.trueLength(finderData.admin.searchTagList.nEditDamageTag) > 0) {
            let nEditDamageTagQuery;
            for (let i = 0; i < finderData.admin.searchTagList.nEditDamageTag.length; i++) {
              let Q = 0;
              let value = finderData.admin.searchTagList.nEditDamageTag[i].value.toString().substr(1);
              if (finderData.admin.searchTagList.nEditDamageTag[i].checked && Q === 0) {
                if (value === 'delDamage')
                  nEditDamageTagQuery = new parse.Query(_damage).notEqualTo('isDeleted', true)
                if (value === 'addDamage')
                  nEditDamageTagQuery = new parse.Query(_damage).equalTo('isAuto', true)
                Q++;
              } else if (finderData.admin.searchTagList.nEditDamageTag[i].checked) {
                let tmpQuery;
                if (value === 'delDamage')
                  tmpQuery = new parse.Query(_damage).equalTo('isDeleted', true)
                if (value === 'addDamage')
                  tmpQuery = new parse.Query(_damage).equalTo('isAuto', true)
                nEditDamageTagQuery = parse.Query.or(nEditDamageTagQuery, tmpQuery);
              }
            }
            damageQuery = parse.Query.and(damageQuery, nEditDamageTagQuery)
          }

          if (this._classificationService.active) {
            damageQuery.equalTo('isAuto', true)
            damageQuery.notEqualTo('classification', true)
            damageQuery.notEqualTo('skipClassification', true)
            damageQuery.notEqualTo('skipClassificationIDK', true)
          }

          damageQuery
            .include('tchekPtr')
            .descending('createdAt')
            .include('tchekPtr.vehiclePtr')
            .include('tchekPtr.devicePtr')
            .limit(finderData.limit * 1000)
            .skip(finderData.skip)
            .count().then(count => { resolve(count) })
        }
      } else {
        query.notEqualTo('isDeleted', true)
          .descending('tchekCreatedAt')
          .include('vehiclePtr')
          .exists('vehiclePtr')
          .include('devicePtr')
          .limit(finderData.limit)
          .skip(finderData.skip)
          .count().then(count => { resolve(count) })
      }
    });
  }


  public getDevices(): Promise<any> {
    return new Promise((resolve, reject) => {
      //const Device = parse.Object.extend('Device');
      const query = new parse.Query('Device');
      query.include("companyPtr")
      query.find().then(
        devices => {
          resolve(devices);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getDevicesTyped(): Promise<Device[]> {
    return new Promise((resolve, reject) => {
      //const Device = parse.Object.extend('Device');
      const query = new parse.Query('Device');
      query.include("companyPtr")
      query.find().then(
        devices => {
          let Array: Device[] = devices.map<Device>(o => new Device(o))
          resolve(Array);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getDevicesCompany(companyPtr): Promise<any> {
    return new Promise((resolve, reject) => {
      console.log("DEBUG: getDevicesCompany");
      //const Device = parse.Object.extend('Device');
      const query = new parse.Query('Device');
      query.equalTo("companyPtr", companyPtr)
      query.include("companyPtr")
      query.find().then(
        devices => {
          resolve(devices);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getAllCompany(): Promise<any> {
    return new Promise((resolve, reject) => {
      //const Device = parse.Object.extend('Device');
      const query = new parse.Query('Company');
      query.include("settingsPtr")
      query.find().then(
        companyList => {
          resolve(companyList);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public getPreviousTchek(tchekId, vehicleID): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const vehiclePtr = {
        __type: 'Pointer',
        className: 'Vehicle',
        objectId: vehicleID
      };

      let tchek = await this._tchekOldService.getTchek(tchekId);
      
      const Tchek = parse.Object.extend('Tchek');
      const query = new parse.Query(Tchek);
      query.notEqualTo('isDeleted', true);
      if (!this.isSuperAdmin && this.companyPtr) {
        await this.fastenSpeedForNonAdmin();
        query.containedIn("devicePtr", this.companyDevicesPtr);
      }
      //query.equalTo("companyPtr", tchek.get('companyPtr'));
      query.equalTo('vehiclePtr', vehiclePtr);
      query.lessThan('tchekCreatedAt', tchek.get('tchekCreatedAt'));
      query.include('vehiclePtr');
      query.include('devicePtr');
      query.descending('tchekCreatedAt');
      query.first().then(
        tchek => {
          resolve(tchek);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  public searchImmat(immat: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const Vehicle = parse.Object.extend('Vehicle');
      const query = new parse.Query(Vehicle);

      let mainQuery = Parse.Query.or(
        query.equalTo('immat', immat),
        query.equalTo('or', immat),
        query.equalTo('vin', immat)
      );
      mainQuery.first().then(
        vehicle => {
          resolve(vehicle);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  // get history of immat
  private vehicleHistory = new Subject<any>();
  vehicleHistoryObs = this.vehicleHistory.asObservable();
  vehicleHistoryF(immat: string) {
    this.vehicleHistory.next(immat)
  }

  // get history of immat
  private readMore = new Subject<any>();
  readMoreObs = this.readMore.asObservable();
  readMoreF() {
    this.readMore.next()
  }


  // set list of tcheck finder result
  TchekList: Array<Tchekb> = [];
  setTchekList(list: Array<Tchekb>) {
    this.TchekList = list;
  }


  public async initAdminSearchData(): Promise<AdminSearch> {
    if (!this.isSuperAdmin)
      return;

    let paramData = this._localStorageService.getItem('finderData');
    let data: FinderData = JSON.parse(paramData);

    if (data && data.admin) {
      console.log('localstorage finderData ADMIN ', JSON.parse(paramData).admin);
      return data.admin
    } else {
      let editDamageList = ['Modifié', 'Supprimé', 'Ajouté'];
      let adminSearchData = new AdminSearch;
      adminSearchData.annotateSearch = false;
      adminSearchData.damageSearch = false;
      adminSearchData.hd = { hd: undefined, nHd: undefined };
      adminSearchData.xhd = { xhd: undefined, nxHd: undefined };
      adminSearchData.note = { note: undefined, nNote: undefined };
      adminSearchData.probalityDamage = { min: undefined, max: undefined };
      adminSearchData.searchTags = [];
      adminSearchData.limit = 15;
      adminSearchData.searchTagList = {
        typeTag: [{ display: 'forValidation', value: '+forValidation', checked: false },
        { display: 'forTest', value: '+forTest', checked: false },
        { display: 'noDevice', value: '+noDevice', checked: false }],
        nTypeTag: [{ display: 'forValidation', value: '-forValidation', checked: false },
        { display: 'forTest', value: '-forTest', checked: false },
        { display: 'noDevice', value: '-noDevice', checked: false }],
        classTag: [],
        nClassTag: [],
        damageTag: Object.entries(this._roiService.vehicleDamageTypes)
          .map<SearchTagCheckbox>(t => ({ display: t[1], value: '+' + t[0], checked: false })).filter(a => { return a.value !== '+added' }),
        nDamageTag: Object.entries(this._roiService.vehicleDamageTypes)
          .map<SearchTagCheckbox>(t => ({ display: t[1], value: '-' + t[0], checked: false })).filter(a => { return a.value !== '-added' }),
        editDamageTag: [],
        nEditDamageTag: [],
        vehiclePartTag: [],
        nVehiclePartTag: [],
        classDetectTag: [],
        nClassDetectTag: [],
        attributesTag: [],
        nAttributesTag: [],
        userAnnotateTag: [],
        nUserAnnotateTag: [],
      }


      this._userService.getAllUsers().then(res => {
        let u: SearchTagCheckbox[] = []
        let nu: SearchTagCheckbox[] = []
        res.forEach(user => {
          let userTmp = new UserParse(user)
          if (userTmp.canAnnotate) {
            u.push({ display: userTmp.username, value: '+' + userTmp.username + ':' + userTmp.id, checked: false })
            nu.push({ display: userTmp.username, value: '-' + userTmp.username + ':' + userTmp.id, checked: false })
          }
        });
        adminSearchData.searchTagList.userAnnotateTag = u;
        adminSearchData.searchTagList.nUserAnnotateTag = nu;
      })

      this._annotationService.getDamageAttributes()
        .then(attributes => {
          adminSearchData.attributes = attributes;
          this.createClassList(attributes, adminSearchData.searchTagList)
        })
        .catch(err => { console.log(err) })

      editDamageList.forEach(element => {
        let value;
        if (element === 'Modifié')
          value = 'editDamage';
        if (element === 'Supprimé')
          value = 'delDamage';
        if (element === 'Ajouté')
          value = 'addDamage';
        adminSearchData.searchTagList.editDamageTag.push({ display: element, value: '+' + value, checked: false })
        adminSearchData.searchTagList.nEditDamageTag.push({ display: element, value: '-' + value, checked: false })
      });
      return adminSearchData;
    }
  }

  createClassList(attributes, list) {
    Object.entries(attributes).forEach(at => {
      if (at[1]) {
        Object.entries(at[1]).forEach(sat => {
          if (sat[1] && Object.values(sat[1]).length > 0) {
            Object.values(sat[1]).forEach(satV => {
              let index = list.attributesTag.findIndex(e => { return e.display === `${sat[0]} ${satV}` });
              if (index === -1) {
                list.nAttributesTag.push({ display: `${sat[0]} ${satV}`, value: `-${sat[0]}:${satV}`, checked: false });
                list.attributesTag.push({ display: `${sat[0]} ${satV}`, value: `+${sat[0]}:${satV}`, checked: false });
              }
            })
          } else {
            let index = list.attributesTag.findIndex(e => { return e.display === `${sat[0]}` });
            if (index === -1) {
              list.nAttributesTag.push({ display: `${sat[0]}`, value: `-${at[0]}:${sat[0]}`, checked: false });
              list.attributesTag.push({ display: `${sat[0]}`, value: `+${at[0]}:${sat[0]}`, checked: false });
            }
          }
        })
      }
      list.nClassTag.push({ display: at[0], value: "-" + at[0], checked: false });
      list.classTag.push({ display: at[0], value: "+" + at[0], checked: false });
    })
  }

  // get finder data 
  finderData: FinderData;
  setFinderData(data: FinderData) {
    console.log("set finder data", data);
    this._localStorageService.setItem('finderData', JSON.stringify(data));
  }

  async getFinderData(): Promise<FinderData> {
    let paramData = this._localStorageService.getItem('finderData');
    let data: FinderData = JSON.parse(paramData);
    console.log('localstorage finderData ', JSON.parse(paramData));


    if (this.finderData)
      return this.finderData;
    else if (data) {
      this.finderData = new FinderData()
      if (this.isSuperAdmin)
        this.finderData.admin = await this.initAdminSearchData()
      this.finderData.activeFilters = data.activeFilters;
      if (data.isDateActive)
        this.finderData.date = { start: this.moment(data.sDate.start), end: this.moment(data.sDate.end) };
      this.finderData.searchTags = data.searchTags;
      this.finderData.limit = data.limit;
      this.finderData.isPicturesHD = data.isPicturesHD;
      this.finderData.isPicturesXHD = data.isPicturesXHD;
      this.finderData.scanAnnotated = data.scanAnnotated;
      this.finderData.scanAnalyzed = data.scanAnalyzed;
      this.finderData.scanForValidation = data.scanForValidation;
      this.finderData.isDateActive = data.isDateActive;
      this.finderData.isDownloaded = data.isDownloaded;
      this.finderData.skip = 0;
      this.finderData.minProbVehicle = data.minProbVehicle;
      this.finderData.statusSelect = data.statusSelect;
      this.finderData.deviceSelect = data.deviceSelect;
    } else {
      let finderData = new FinderData;
      finderData.statusSelect = null
      finderData.limit = 15;
      finderData.skip = 0;
      finderData.deviceSelect = null
      if (this.isSuperAdmin)
        finderData.admin = await this.initAdminSearchData();
      this.finderData = finderData;
    }
    console.log('result get finder data ', JSON.parse(JSON.stringify(this.finderData)));
    return this.finderData;
  }


  trueLength(list: SearchTagCheckbox[]): number {
    let i = 0;
    if (list)
      list.forEach(element => {
        if (element.checked === true)
          i++;
      });
    return i;
  }

}






// WEBPACK FOOTER //
// ./src/app/service/search.service.ts